<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <div>
                    <el-tabs :tab-position="'top'" type="">
                        <el-tab-pane :label="$t('getapi[6020]')">
                            <div style="background: white;white-space: nowrap;overflow: auto">
                                <el-button type="primary" size="mini" @click.native.prevent="showAddMaterials">{{$t('getapi[878]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click.native.prevent="batchEdl">{{$t('getapi[7241]')}}</el-button>
                            </div>
                            <el-table :data="dataSetMaterials" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName" border
                                      size="mini"
                                      :height="tableHeight - reduceTableHeight
"
                                      header-row-class-name="headerclass"
                                      style="width: 100%; margin-top:0px"
                                      :header-cell-style="$limits.headerClass"
                                      ref="singleTable">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID"
                                                 v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                                <el-table-column prop="number" :label="$t('getapi[1628]')" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.number" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"  width="80"></el-table-column>
                                <el-table-column :label="$t('getapi[6048]')"  width="80">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delMaterials(scope.$index)"
                                        >
                                            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[3889]')
                                                }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <!--<el-tab-pane :label="$t('getapi[6021]')">
                            <div style="background: white;white-space: nowrap;overflow: auto">
                                <el-button type="primary" size="mini" @click.native.prevent="showAddPlanNumber">新增</el-button>
                                <el-button type="primary" size="mini" @click.native.prevent="batchEdl">批量删除</el-button>
                            </div>
                            <el-table :data="dataSetPlanNumber" @selection-change="handleSelectionPlanChange" v-loading="loading" size="mini" border style="width: 100%">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="planno" label="计划单号">
                                    <template slot-scope="scope" v-show="editf">
                                        <el-input v-model="scope.row.planno" size="mini" style="width:120px"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip fixed="right" :label="$t('basic.edit')">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                            :confirmButtonText="$t('getapi[937]')"
                                            :cancelButtonText="$t('getapi[6]')"
                                            icon="el-icon-info"
                                            iconColor="red"
                                            :title="$t('getapi[637]')"
                                            @onConfirm="delPlanNumber(scope.$index)"
                                        >
                                            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[3889]') }}</el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>-->
                    </el-tabs>
                </div>
                <div style="position: absolute;bottom:10px">
                    <el-button type="primary" size="mini" @click.native.prevent="selectInfo">{{$t('getapi[2530]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native.prevent="clear">{{$t('getapi[2026]')}}
                    </el-button>
                </div>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    <el-tabs :tab-position="'top'" type="" v-model="activeName" @tab-click="selectInfo">
                        <el-tab-pane :label="$t('getapi[1565]')" name="1">
                            <div>
                                <el-button type="primary" size="mini" @click="transfer" :disabled="!btn.transfer">{{ $t('getapi[6023]') }}
                                </el-button>
                            </div>
                            <ul class="Boxs" ref="Box" :style="{ height: tableHeight - 45 + 'px' }">
                                <li style="width: 100%; margin-top:0px">
                                    <wTable id="xpane-0" :data="dataSetDetail" :loading="loading" :header="tableHeader" @handleSelectionChange="handleSelectionChange1" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"
                                            ref="singleTable1"></wTable>
                                </li>
                            </ul>
                            <!-- <el-table
                                    :data="dataSetDetail"
                                    v-loading="loading"
                                    :height="tableHeight - 60"
                                    size="mini"
                                    border
                                    style="width: 100%; margin-top:0px"
                                    @selection-change="handleSelectionChange1"
                            >
                                <el-table-column type="selection" :selectable="checkSelect"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code"
                                                 :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version"
                                                 :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_ENGTYPE_NAME"
                                                 :label="$t('getapi[118]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit"
                                                 :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="require_qty" :label="$t('getapi[1567]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_require_qty" :label="$t('getapi[1568]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="onHand_qty" :label="$t('getapi[1569]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="onHand_remain_qty"
                                                 :label="$t('getapi[1570]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="lowerLimit_qty"
                                                 :label="$t('getapi[157]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="on_qty" :label="$t('getapi[1571]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="addPur_remain_qty"
                                                 :label="$t('getapi[1572]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="pur_cycle" :label="$t('getapi[1520]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="min_Pur_batch" :label="$t('getapi[1574]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_type"
                                                 :label="$t('getapi[3628]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ownered_product"
                                                 :label="$t('getapi[145]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="order_increment"
                                                 :label="$t('getapi[164]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="suggest_qty" label="建议采购量"
                                                 align="right"></el-table-column>
                            </el-table> -->
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <!-- 新增物料弹框 -->
        <!--<OM :isVisible="addmaterialsvisible" @addmaterials="addmaterials" ref="addmaterials"></OM>-->
        <selector :isVisible="addmaterialsvisible" :selectType="4" :isBatch=true :isSplitPage=true
                  :postUrl="'/Pur/Requisition/GetSimulationPurPartPopupList'" @callback="addmaterials" @dialogVis="dialogVis"
                  ref="addmaterials"></selector>
        <el-dialog v-dialogDrag :visible.sync="isShowTransfer" :title="$t('getapi[6023]')" width="15%" :modal-append-to-body="false">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[1480]')}}</td><!--计划标识-->
                        <td>
                            <el-input v-model="PlanNo" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[1479]')}}</td><!--项目-->
                        <td>
                            <routejump :urlNo="5">
                            <el-input
                                    v-model="item_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:120px"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem_code()"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowTransfer = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="mini" type="primary" @click="confirmTransfer">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--<itemCode :isVisible="isShowItem" @getproject="getproject" ref="input"></itemCode>-->
        <selector :isVisible="isShowItem" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Pur/Requisition/GetSimulationItemPopupList'" @callback="getproject" ref="input"></selector>

        <!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[6548]')" queryData="FrmSimulationPart" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'purschemesimulation',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1-20,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1-20,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSetMaterials: [], //物料
                dataSetPlanNumber: [], //计划清单
                dataSetDetail: [], //模拟配料
                loading: false,
                addmaterialsvisible: false, // 新增物料弹窗
                selectIDData: [], // 物料多选ID合集
                selectIDPlanData: [], // 物料多选ID合集
                selectIndex: 0, // 分页
                selectData: [], // 多选（按采购件新算法）
                PlanNo: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                isShowItem: false,
                reduceTableHeight: Common.reduceTableHeight1_1,
                height1: window.innerHeight - 230 + 'px',
                btn: {
                    transfer: false
                },
                activeName:'1',
                tableHeader: [],
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.$limits.dragControllerDiv1();
            that.authority();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('FrmSimulationPart',0,PFileds=>{
                    that.tableHeader=PFileds;		
                });	
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            tableRowClassName({row, rowIndex}){
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6548]"),this.$t("getapi[16]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                that.$refs.SetBtn.SetButtonEnable('export');
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.transfer = false
                let flag = true
                if(that.selectData.length > 0){
                    for(let i = 0;i<that.selectData.length;i++){
                        if(that.selectData[i].suggest_qty == 0){
                            flag = false
                            return
                        }
                    }
                } else {
                    flag = false
                }
                if(flag){
                    that.btn.transfer = true
                } else {
                    that.btn.transfer = false
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            dialogVis(val){
                let that = this;
                that.addmaterialsvisible = val;
            },
            // 添加物料
            showAddMaterials() {
                let that = this;
                that.addmaterialsvisible = true;
                that.$refs.addmaterials.clearInput(that.addmaterialsvisible, true, 4);
            },
            addmaterials(data) {
                let that = this;
                console.log(data);
                for (let i = 0; i < data.length; i++) {
                    that.dataSetMaterials = [
                        ...that.dataSetMaterials,
                        {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            exclusively_id: data[i].exclusively_id,
                            number: 1
                        }
                    ];
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].exclusively_id);
                }
            },
            // 计划单号清单批量选择
            handleSelectionPlanChange(val) {
                let that = this;
                that.selectIDPlanData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDPlanData.push(val[i].$index);
                }
            },
            // 批量删除
            batchEdl() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            // 计划单号清单批量删除
            batchEdlPlan() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            // 模拟配料切换
            selectInfo() {
                let that = this;
                that.loading = true;
                let parm = {
                    List: [],
                    LangType: that.$processdata.getLang(),
                }
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    parm.List.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        number: that.dataSetMaterials[i].number
                    });
                }
                that.$http.urlpost('/Pur/Requisition/GetSimulationPurPartList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSetDetail = res.DataContent.DataList;
                        that.$nextTick(function () {
                            that.$processdata.initForm(0)
                        })
                    }
                    that.loading = false;
                });
            },
            clear(){
              let that = this
              that.dataSetMaterials = []
              that.dataSetDetail = []
            },
            //导出
            exps() {
                let that = this;
                //that.selectIndex = tab.name;
                that.loading = true;
                let parm = {
                    List: []
                }
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    parm.List.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        number: that.dataSetMaterials[i].number
                    });
                }
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Pur/Requisition/GetSimulationPurPartToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 新增计划单号清单
            showAddPlanNumber() {
                let that = this;
                that.dataSetPlanNumber = [
                    ...that.dataSetPlanNumber,
                    {
                        planno: ''
                    }
                ];
            },
            //  删除物料
            delMaterials(index) {
                let that = this;
                that.dataSetMaterials.splice(index, 1);
            },
            //  删除计划单号
            delPlanNumber(index) {
                let that = this;
                that.dataSetPlanNumber.splice(index, 1);
            },
            // 转单
            transfer() {
                let that = this;
                if(that.$limits.authority('plv4', 41, 1) == 0){
                    that.$message.warning(that.$t('getapi[8760]'))//没有转单权限!
                    return false
                }
                that.isShowTransfer = true;
                that.PlanNo = ''
                that.item_code = ''
            },
            confirmTransfer() {
                let that = this;
                let parm = {
                    planno: that.PlanNo,
                    item_code: that.item_code,
                    List: [],
                    LangType: that.$processdata.getLang(),
                };
                for(let i = 0;i<that.selectData.length;i++){
                    parm.List = [...parm.List,{
                        part_code: that.selectData[i].part_code,
                        part_version: that.selectData[i].part_version,
                        suggest_qty: that.selectData[i].suggest_qty,
                        pur_cycle: that.selectData[i].pur_cycle
                    }]
                }
                that.$http.urlpost('/Pur/Requisition/GetSimulationPurPartToPlan', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowTransfer = false;
                    }
                });
            },
            checkSelect(val){
                let that = this
                return val.suggest_qty != 0
            },
            handleSelectionChange1(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    if(val[i].suggest_qty>0){
                        that.selectData.push({
                            part_code: val[i].part_code,
                            part_version: val[i].part_version,
                            suggest_qty: val[i].suggest_qty,
                            pur_cycle: val[i].pur_cycle
                        });
                    }
                }
                that.btnauthority()
            },
            selectItem_code() {
                let that = this;
                that.isShowItem = true;
                that.$refs.input.clearInput(this.isShowItem);
            },
            getproject(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if((this.$route.name == this.$options.name) && (that.addmaterialsvisible == false)){
                    if(e.clipboardData){
                        var data = e.clipboardData.getData('Text');
                        if(!that.$limits.fnIsEmpty(data)){
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1){
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: '',
                            exclusively_id: '',
                            number: 0
                        }]
                    } else if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            qty: arr[i].split('\\t')[1],
                            part_version: ''
                        }]
                    } else {
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[2],
                            exclusively_id: '',
                            number: arr[i].split('\\t')[1]
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    let parm = {
                        list: arrlist
                    }
                    that.$http.urlpost('/Pur/Requisition/PurSimulationPasteByPartCode', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent.List
                            for (let i = 0; i < data.length; i++) {
                                that.dataSetMaterials = [...that.dataSetMaterials, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    exclusively_id: data[i].exclusively_id,
                                    number: data[i].number
                                }]
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
